document.addEventListener('DOMContentLoaded', function () {
  const wrappers = document.querySelectorAll('.shop-deals-wrapper');

  wrappers.forEach(function (wrapper) {
    const track = wrapper.querySelector('.grid');
    if (!track) return;

    const slides = Array.from(track.children);
    if (slides.length === 0) return;

    // Clone slides for infinite loop
    slides.forEach(function (slide) {
      const clone = slide.cloneNode(true);
      track.appendChild(clone);
    });

    let slideWidth = slides[0].offsetWidth + parseInt(getComputedStyle(track).gap || 0);
    let currentX = 0;
    let autoPlayInterval;
    let isDragging = false;
    let startX = 0;
    let startScroll = 0;

    function updateSlideWidth() {
      slideWidth = slides[0].offsetWidth + parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 20);
    }

    function autoSlide() {
      currentX -= 1;
      // Reset for infinite loop
      if (Math.abs(currentX) >= slides.length * slideWidth) {
        currentX = 0;
      }
      track.style.transform = 'translateX(' + currentX + 'px)';
    }

    function startAutoPlay() {
      autoPlayInterval = setInterval(autoSlide, 20);
    }

    function stopAutoPlay() {
      clearInterval(autoPlayInterval);
    }

    // Start auto play
    updateSlideWidth();
    startAutoPlay();

    // Mouse drag
    track.addEventListener('mousedown', function (e) {
      isDragging = true;
      startX = e.pageX;
      startScroll = currentX;
      stopAutoPlay();
      track.style.transition = 'none';
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDragging) return;
      const diff = e.pageX - startX;
      currentX = startScroll + diff;
      track.style.transform = 'translateX(' + currentX + 'px)';
    });

    document.addEventListener('mouseup', function () {
      if (!isDragging) return;
      isDragging = false;
      track.style.transition = 'transform 0.5s ease';
      startAutoPlay();
    });

    // Touch drag
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].pageX;
      startScroll = currentX;
      stopAutoPlay();
      track.style.transition = 'none';
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      const diff = e.touches[0].pageX - startX;
      currentX = startScroll + diff;
      track.style.transform = 'translateX(' + currentX + 'px)';
    }, { passive: true });

    track.addEventListener('touchend', function () {
      track.style.transition = 'transform 0.5s ease';
      startAutoPlay();
    });

    // Pause on hover
    wrapper.addEventListener('mouseenter', stopAutoPlay);
    wrapper.addEventListener('mouseleave', startAutoPlay);

    window.addEventListener('resize', function () {
      updateSlideWidth();
    });
  });
});
